"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationHeader = void 0;
var React = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles = __importStar(require("./NavigationHeader.css"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var dynamic_1 = require("@vanilla-extract/dynamic");
var DrawerToggleButton_1 = require("./DrawerToggleButton");
var NavigationContext_1 = require("./NavigationContext");
var PubSub_1 = require("../PubSub/PubSub");
var FormatDecimals_1 = require("../Quote/FormatDecimals");
var EngagementMenu_1 = require("../Springboard/EngagementMenu");
var Goldilocks_1 = __importDefault(require("../Goldilocks"));
var scrollTo_1 = require("../Util/scrollTo");
var TelemetryContext_1 = require("../Telemetry/TelemetryContext");
var NavigationTheming_css_1 = require("./NavigationTheming.css");
var NavigationTheming_1 = require("./NavigationTheming");
var colord_1 = require("colord");
var AcceptPrompt_1 = require("./AcceptPrompt");
var acceptPromptStyles = __importStar(require("./AcceptPrompt.css"));
var useOverlayPosition_1 = require("./useOverlayPosition");
var StoredState_1 = require("../StoredState/StoredState");
var zod_1 = require("zod");
var DocumentSavedPrompt_1 = require("./Prompts/DocumentSavedPrompt");
var SpringboardEngagementViewStoreContext_1 = require("../Springboard/SpringboardEngagementViewStoreContext");
var SpringboardApi_1 = require("../Springboard/SpringboardApi");
var ConfigurationContext_1 = require("../Page/ConfigurationContext");
var AuthenticationContext_1 = require("../Springboard/AuthenticationContext");
var MaybeWithTooltip = function (_a) {
    var isAccepted = _a.isAccepted, isCollaborator = _a.isCollaborator, collaboratorPreviewEnabled = _a.collaboratorPreviewEnabled, children = _a.children, showingPrompt = _a.showingPrompt, buttonDisabled = _a.buttonDisabled;
    var getButtonDisabledReason = function () {
        if (isCollaborator && !collaboratorPreviewEnabled) {
            return "This page is for internal collaboration only - use the Shareable Link to allow clients to accept";
        }
        else if (isAccepted) {
            return "Looks like this project has already been accepted.";
        }
        else {
            return "";
        }
    };
    if (buttonDisabled && !showingPrompt) {
        return (React.createElement(kaleidoscope_1.Tooltip, { wrapTarget: true, className: styles.acceptButtonTooltip, content: getButtonDisabledReason(), size: kaleidoscope_1.TooltipSize.Large, autoStack: false }, children));
    }
    return React.createElement(React.Fragment, null, children);
};
var EitherAcceptPromptOrDocumentSavedNotification = function (_a) {
    var isShowingAcceptPrompt = _a.isShowingAcceptPrompt, isShowingDocumentSavedPrompt = _a.isShowingDocumentSavedPrompt, acceptPromptRef = _a.acceptPromptRef, acceptPromptOverlayPositionProps = _a.acceptPromptOverlayPositionProps, showSpringboardAcceptDiscovery = _a.showSpringboardAcceptDiscovery, handleCloseDocumentSavedPrompt = _a.handleCloseDocumentSavedPrompt, accept = _a.accept, handleCloseAcceptPrompt = _a.handleCloseAcceptPrompt, showPaymentsPrompt = _a.showPaymentsPrompt;
    if (showSpringboardAcceptDiscovery && isShowingDocumentSavedPrompt && !showPaymentsPrompt) {
        return React.createElement(DocumentSavedPrompt_1.DocumentSavedPrompt, { onClose: handleCloseDocumentSavedPrompt });
    }
    else if (isShowingAcceptPrompt) {
        return (React.createElement(AcceptPrompt_1.AcceptPrompt, { esignEnabled: accept === null || accept === void 0 ? void 0 : accept.esignEnabled, onClose: handleCloseAcceptPrompt, ref: acceptPromptRef, overlayPositionProps: acceptPromptOverlayPositionProps, paymentsEnabledAndDiscoverable: showPaymentsPrompt }));
    }
    return React.createElement(React.Fragment, null);
};
var shouldDisableButton = function (isCollaborator, projectAccepted, acceptData) {
    if (acceptData === null || acceptData === void 0 ? void 0 : acceptData.hasAgreement) {
        return false;
    }
    if (projectAccepted || (acceptData === null || acceptData === void 0 ? void 0 : acceptData.isAccepted)) {
        return true;
    }
    if (isCollaborator) {
        if (acceptData === null || acceptData === void 0 ? void 0 : acceptData.collaboratorPreviewEnabled) {
            return false;
        }
        return true;
    }
    return false;
};
var NavigationHeader = function (_a) {
    var _b;
    var _c, _d;
    var _e = _a.title, title = _e === void 0 ? "Untitled" : _e, layout = _a.layout, showDrawer = _a.showDrawer, mode = _a.mode, quote = _a.quote, accept = _a.accept, isCollaborator = _a.isCollaborator, backgroundColor = _a.backgroundColor, showSpringboardAcceptDiscovery = _a.showSpringboardAcceptDiscovery, paymentSettings = _a.paymentSettings;
    var _f = __read(React.useState(false), 2), showAcceptPrompt = _f[0], setShowAcceptPrompt = _f[1];
    var _g = __read(React.useState(false), 2), showDocumentSavedPrompt = _g[0], setShowDocumentSavedPrompt = _g[1];
    var navigationContext = (0, NavigationContext_1.useNavigationContext)();
    var _h = (0, ConfigurationContext_1.useConfigurationContext)(), pageHash = _h.pageHash, publicApiBaseUrl = _h.publicApiBaseUrl;
    var _j = (0, AuthenticationContext_1.useAuthenticationContext)(), getToken = _j.getToken, isSignedIn = _j.isSignedIn;
    var track = (0, TelemetryContext_1.useTelemetry)().track;
    var showPaymentsPrompt = ((paymentSettings === null || paymentSettings === void 0 ? void 0 : paymentSettings.enabled) && (paymentSettings === null || paymentSettings === void 0 ? void 0 : paymentSettings.discoverable)) || false;
    var showingPrompt = showAcceptPrompt || showDocumentSavedPrompt || showPaymentsPrompt;
    var _k = __read((0, StoredState_1.useLocalStorage)({
        key: "qwilr:accept-prompt-viewed",
        schema: zod_1.z.boolean(),
        default: false,
    }), 2), acceptPromptViewed = _k[0], setAcceptPromptViewed = _k[1];
    var _l = __read((0, StoredState_1.useLocalStorage)({
        key: "qwilr:payments-accept-prompt-pages",
        schema: zod_1.z.array(zod_1.z.string()),
        default: [],
    }), 2), paymentsPromptPages = _l[0], setPaymentsPromptPages = _l[1];
    var _m = __read((0, StoredState_1.useLocalStorage)({
        key: SpringboardEngagementViewStoreContext_1.ACTION_SPRINGBOARD_DISCOVERY_LOCALSTORAGE_KEY,
        schema: zod_1.z.boolean(),
        default: false,
    }), 2), pendingSpringboardDiscoveryAction = _m[0], setPendingSpringboardDiscoveryAction = _m[1];
    var _o = __read((0, PubSub_1.usePubSubEvent)("qwilr:quote-total-changed", {
        total: quote ? quote.initialTotal : 0,
    }), 1), total = _o[0].total;
    var _p = __read((0, PubSub_1.usePubSubEvent)("qwilr:project-accepted", {
        projectAccepted: (_c = accept === null || accept === void 0 ? void 0 : accept.isAccepted) !== null && _c !== void 0 ? _c : false,
    }), 1), projectAccepted = _p[0].projectAccepted;
    PubSub_1.PubSub.subscribe("qwilr:engagement-menu-clicked", function (_a) {
        var clicked = _a.clicked;
        if (clicked) {
            handleCloseAcceptPrompt();
            handleCloseDocumentSavedPrompt();
        }
    });
    var disableButton = shouldDisableButton(isCollaborator !== null && isCollaborator !== void 0 ? isCollaborator : false, projectAccepted, accept);
    var handleAcceptClick = function () {
        handleCloseAcceptPrompt();
        handleCloseDocumentSavedPrompt();
        var acceptButtonSelector = ".accept-button-v2__button";
        var actualAcceptButton = document.querySelector(acceptButtonSelector);
        var foldedBlockShowHideButton = document.querySelector(".accept-module .label-container");
        if (foldedBlockShowHideButton) {
            var isExpanded = foldedBlockShowHideButton === null || foldedBlockShowHideButton === void 0 ? void 0 : foldedBlockShowHideButton.getAttribute("aria-expanded");
            if (isExpanded == "false") {
                foldedBlockShowHideButton.click();
                (0, scrollTo_1.scrollTo)(".project-block .accept-wrapper");
                document.querySelector(acceptButtonSelector).click();
            }
        }
        else if (actualAcceptButton) {
            actualAcceptButton.click();
        }
        else {
            (0, scrollTo_1.scrollTo)(".project-block .accept-wrapper");
        }
        if (mode === "public") {
            track("Navigation Used", { feature_used: "clicked CTA" });
        }
    };
    var acceptPromptViewedActioned = React.useRef(false);
    React.useEffect(function () {
        if (acceptPromptViewedActioned.current) {
            return;
        }
        if (accept) {
            var paymentsPromptViewed = paymentsPromptPages.includes(pageHash);
            setShowAcceptPrompt((showPaymentsPrompt ? !paymentsPromptViewed : !acceptPromptViewed) && !disableButton);
            if (showPaymentsPrompt) {
                if (!paymentsPromptViewed) {
                    setPaymentsPromptPages(__spreadArray([pageHash], __read(paymentsPromptPages), false).slice(0, 20));
                }
            }
            else if (!acceptPromptViewed) {
                setAcceptPromptViewed(true);
            }
            acceptPromptViewedActioned.current = true;
        }
    }, [
        accept,
        disableButton,
        acceptPromptViewed,
        setAcceptPromptViewed,
        pageHash,
        showPaymentsPrompt,
        paymentsPromptPages,
        setPaymentsPromptPages,
    ]);
    var hasActionedSpringboardDiscovery = React.useRef(false);
    var isActioningSpringboardDiscovery = React.useRef(false);
    React.useEffect(function () {
        if (hasActionedSpringboardDiscovery.current || isActioningSpringboardDiscovery.current) {
            return;
        }
        var handleDiscoveryActions = function () { return __awaiter(void 0, void 0, void 0, function () {
            var acceptToken;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!pendingSpringboardDiscoveryAction) return [3, 2];
                        isActioningSpringboardDiscovery.current = true;
                        if (!isSignedIn) return [3, 2];
                        setShowDocumentSavedPrompt(true);
                        acceptToken = (_a = window.localStorage.getItem("qwilr:accept-token")) !== null && _a !== void 0 ? _a : "";
                        return [4, springboardDiscoveryActions(getToken, pageHash, publicApiBaseUrl, acceptToken)];
                    case 1:
                        _b.sent();
                        setPendingSpringboardDiscoveryAction(false);
                        hasActionedSpringboardDiscovery.current = true;
                        window.localStorage.setItem("qwilr:accept-token", "");
                        _b.label = 2;
                    case 2: return [2];
                }
            });
        }); };
        handleDiscoveryActions().catch(function (err) {
            console.error("Failed to action pending discovery actions", err);
            isActioningSpringboardDiscovery.current = false;
            setPendingSpringboardDiscoveryAction(false);
            window.localStorage.setItem("qwilr:accept-token", "");
        });
    }, [
        getToken,
        isSignedIn,
        pageHash,
        pendingSpringboardDiscoveryAction,
        publicApiBaseUrl,
        setPendingSpringboardDiscoveryAction,
    ]);
    var promptOffset = layout === "top" ? 12 : 4;
    var _q = (0, useOverlayPosition_1.useOverlayPosition)({
        caretSize: acceptPromptStyles.caretSize,
        offset: promptOffset,
        outerMargin: 4,
    }), promptProps = _q.overlayProps, acceptPromptRef = _q.overlayRef, acceptButtonRef = _q.targetRef;
    if (!navigationContext.showNavWhileEditing) {
        return null;
    }
    var handleCloseAcceptPrompt = function () {
        setShowAcceptPrompt(false);
    };
    var handleCloseDocumentSavedPrompt = function () {
        setShowDocumentSavedPrompt(false);
    };
    var actionsAreFloating = layout !== "top";
    var MaybeActionsWithPanel = actionsAreFloating ? kaleidoscope_1.Panel : "div";
    var featuresEnabled = !!accept || !!quote;
    return (React.createElement("header", { className: (0, clsx_1.default)(styles.header({ layout: layout, mode: mode }), NavigationTheming_css_1.navigationElement), style: (0, NavigationTheming_1.getNavThemeInlineVars)(backgroundColor) },
        layout === "top" && (React.createElement("div", { className: styles.toggleGroup },
            React.createElement("div", null, showDrawer && React.createElement(DrawerToggleButton_1.DrawerToggleButton, null)),
            React.createElement(kaleidoscope_1.Text, { size: "s", strong: true, className: styles.title }, title))),
        React.createElement("div", { className: styles.actions },
            React.createElement(MaybeActionsWithPanel, { className: styles.actionsRight({
                    floating: actionsAreFloating,
                    floatingAndFeaturesEnabled: actionsAreFloating && featuresEnabled,
                }) },
                quote && (React.createElement(kaleidoscope_1.Text, { size: "s", strong: true, className: styles.quoteTotal }, (0, FormatDecimals_1.formatWithDecimals)(total, quote.currency, {
                    showDecimalPlaces: quote.showDecimalPlaces,
                    locale: quote.currencyLocale,
                }))),
                accept && (React.createElement("div", { className: styles.acceptContainer },
                    React.createElement(MaybeWithTooltip, { isAccepted: accept.isAccepted || projectAccepted, isCollaborator: isCollaborator || false, buttonDisabled: disableButton, showingPrompt: showingPrompt, collaboratorPreviewEnabled: accept.collaboratorPreviewEnabled || false },
                        React.createElement(kaleidoscope_1.Button, { disabled: disableButton, className: styles.acceptButton, size: kaleidoscope_1.ButtonSize.Medium, style: (0, dynamic_1.assignInlineVars)((_b = {},
                                _b[styles.acceptButtonColor] = accept.color,
                                _b[styles.acceptButtonHoverColor] = (0, colord_1.colord)(accept.color).alpha(0.25).toRgbString(),
                                _b[styles.acceptButtonTextColor] = (0, Goldilocks_1.default)(accept.color, { mode: "text" }),
                                _b)), onClick: handleAcceptClick, innerRef: acceptButtonRef, "data-qwilr-component": "nav-accept-button" },
                            React.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, (_d = accept.label) !== null && _d !== void 0 ? _d : "Accept")),
                        mode === "public" && (React.createElement(EitherAcceptPromptOrDocumentSavedNotification, { isShowingAcceptPrompt: showAcceptPrompt, isShowingDocumentSavedPrompt: showDocumentSavedPrompt, acceptPromptOverlayPositionProps: promptProps, acceptPromptRef: acceptPromptRef, accept: accept, handleCloseAcceptPrompt: handleCloseAcceptPrompt, handleCloseDocumentSavedPrompt: handleCloseDocumentSavedPrompt, showSpringboardAcceptDiscovery: showSpringboardAcceptDiscovery, showPaymentsPrompt: showPaymentsPrompt }))))),
                React.createElement(EngagementMenu_1.SpringboardEngagementMenu, null)))));
};
exports.NavigationHeader = NavigationHeader;
var springboardDiscoveryActions = function (getAuthToken, projectSecret, domain, acceptToken) { return __awaiter(void 0, void 0, Promise, function () {
    var token, authHeader, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, getAuthToken()];
            case 1:
                token = _a.sent();
                if (!token) return [3, 5];
                authHeader = (0, SpringboardApi_1.makeAuthHeader)(token);
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4, fetch("".concat(domain, "/projects/").concat(projectSecret, "/late-auth-post-accept"), {
                        headers: __assign({ "Content-Type": "application/json" }, authHeader),
                        method: "POST",
                        body: JSON.stringify({ acceptToken: acceptToken }),
                    })];
            case 3:
                _a.sent();
                return [2, true];
            case 4:
                error_1 = _a.sent();
                console.log("Error handling post accept actions", error_1);
                throw error_1;
            case 5: return [2];
        }
    });
}); };
